import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import { CurrencyrateList_currencyrates_edges_node } from "@saleor/currencyrate/types/CurrencyrateList";
import { CurrencyrateListUrlSortField } from "@saleor/currencyrate/urls";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Container from "../../../components/Container";
import PageHeader from "../../../components/PageHeader";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SortPage,
  TabPageProps
} from "../../../types";
import CurrencyrateList from "../CurrencyrateList";
import {
  createFilterStructure,
  CurrencyrateFilterKeys,
  CurrencyrateListFilterOpts
} from "./filters";

export interface CurrencyrateListPageProps
  extends PageListProps,
    ListActions,
    FilterPageProps<CurrencyrateFilterKeys, CurrencyrateListFilterOpts>,
    SortPage<CurrencyrateListUrlSortField>,
    TabPageProps {
  currencyrate: CurrencyrateList_currencyrates_edges_node[];
  onBack: () => void;
  onApply: (currency: any) => any;
  showEvent:()=>void;
  toatlCount:number;
}

const CurrencyrateListPage: React.FC<CurrencyrateListPageProps> = ({
  currencySymbol,
  filterOpts,
  initialSearch,
  onAdd,
  showEvent,
  onBack,
  onFilterChange,
  onSearchChange,
  currentTab,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  onApply,
  toatlCount,
  ...listProps
}) => {
  const intl = useIntl();

  const structure = createFilterStructure(intl, filterOpts);

  return (
    <Container>
      <AppHeader onBack={onBack}>
        <FormattedMessage {...sectionNames.configuration} />
      </AppHeader>
      <PageHeader title={intl.formatMessage(sectionNames.currencyrates)+"("+toatlCount+")"}>
        <Button onClick={showEvent} color="primary" variant="contained">
          <FormattedMessage
            defaultMessage="Event"
            description="button"
          />
        </Button>
        <div style={{width:"20px"}}/>
        <Button onClick={onAdd} color="primary" variant="contained">
          <FormattedMessage
            defaultMessage="Create currencyrate"
            description="button"
          />
        </Button>
        
      </PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All Currencyrates",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Currencyrate"
          })}
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <CurrencyrateList onApply={onApply} {...listProps} />
      </Card>
    </Container>
  );
};
export default CurrencyrateListPage;
